module Meevo.Components.Controls.SmartMover {
    import ProductSubCategory = Model.ProductSubCategory;

    export class ProductSubCategoriesCollection extends SmartMoverApiCollection<ProductSubCategory> implements IApiCollection<ProductSubCategory> {

        protected get smartMoverHiddenValue() {
            return SmartMoverHiddenValue.EmptyArray;
        }

        get url() {
            return 'ProductSubCategory';
        }

    }

}